var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 7,
    viewBox: "0 0 7 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 2.14795L5.54982 0.0981284C5.68066 -0.0327095 5.89001 -0.0327095 6.02959 0.0981284L6.90187 0.979111C7.03271 1.10995 7.03271 1.32801 6.90187 1.45888L4.86075 3.5L6.90187 5.54982C7.03271 5.68066 7.03271 5.89001 6.90187 6.02959L6.02959 6.90187C5.89001 7.03271 5.68069 7.03271 5.54982 6.90187L3.5 4.86075L1.45888 6.90187C1.32804 7.03271 1.10998 7.03271 0.979111 6.90187L0.0981284 6.02959C-0.0327095 5.89001 -0.0327095 5.68069 0.0981284 5.54982L2.14795 3.5L0.0981284 1.45888C-0.0327095 1.32804 -0.0327095 1.10998 0.0981284 0.979111L0.979111 0.0981284C1.10995 -0.0327095 1.32801 -0.0327095 1.45888 0.0981284L3.5 2.14795Z",
    fill: "#603004"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.ba74e4269bf902b26cf01fb00af6da82.svg";
export { ForwardRef as ReactComponent };